import Model from './Model'

export default class AiUsage extends Model {
    resource()
    {
        return 'ai-usages'
    }
}
